import React from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 67%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileEmployer2 = () => {
    const navigate = useNavigate();

    const {createCompany, getManagerInformation} = usePortalService();

    const [firstName, setFirstName] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [companyNameDirty, setCompanyNameDirty] = useState(false);
    const [companyNameError, setCompanyNameError] = useState('Введите название компании');

    const regWebsite = /\S+\.\S+/;
    const [website, setWebsite] = useState('');
    const [websiteDirty, setWebsiteDirty] = useState(false);
    const [websiteError, setWebsiteError] = useState('Укажите сайт компании');

    const [area, setArea] = useState('');
    const [areaDirty, setAreaDirty] = useState(false);
    const [areaError, setAreaError] = useState('Укажите область');

    const [city, setCity] = useState('');
    const [cityDirty, setCityDirty] = useState(false);
    const [cityError, setCityError] = useState('Укажите город');

    const [street, setStreet] = useState('');
    const [streetDirty, setStreetDirty] = useState(false);
    const [streetError, setStreetError] = useState('Укажите улицу');

    const [house, setHouse] = useState('');
    const [houseDirty, setHouseDirty] = useState(false);
    const [houseError, setHouseError] = useState('Укажите дом');

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'companyName':
                setCompanyNameDirty(true)
                break;
            case 'website':
                setWebsiteDirty(true)
                break;
            case 'area':
                setAreaDirty(true)
                break;
            case 'city':
                setCityDirty(true)
                break;
            case 'street':
                setStreetDirty(true)
                break;
            case 'house':
                setHouseDirty(true)
                break;
        }
    }

    const companyNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCompanyName(e.target.value)
        if (e.target.value.length == 0) {
            setCompanyNameError('Название компании не может быть пустым')
        } else if (e.target.value.length < 2) {
            setCompanyNameError('Название компании не может состоять из одного символа')
        } else {
            setCompanyNameError('')
        }
    }

    const websiteHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setWebsite(e.target.value)
        if (!regWebsite.test(String(e.target.value).toLowerCase())) {
            setWebsiteError('Некорректный адрес сайта')
        } else {
            setWebsiteError('')
        }
    }

    const areaHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setArea(e.target.value)
        setAreaError('')
    }

    const cityHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCity(e.target.value)
        setCityError('')
    }

    const streetHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setStreet(e.target.value)
        setStreetError('')
    }

    const houseHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setHouse(e.target.value)
        setHouseError('')
    }

    useEffect(() => {
        getManagerInformation().then(result => {
            setFirstName(result.manager.firstName);
        });
    }, []);

    const handleContinue = async (e: React.FormEvent) => {
        e.preventDefault();
        if (companyNameError || websiteError || areaError || cityError || streetError || houseError) {
            setCompanyNameDirty(true)
            setWebsiteDirty(true)
            setAreaDirty(true)
            setCityDirty(true)
            setStreetDirty(true)
            setHouseDirty(true)
        } else {
            const result = await createCompany({
                name: companyName,
                linkToSite: website,
                region: area,
                city,
                street,
                house
            });
    
            if (result.success) {
                navigate("/fillProfile3");
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName} />
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <p className="step">Шаг 2 из 3</p>
                        <h1 style={{ marginBottom: '32px' }}> Информация о компании </h1>
                        <Form>
                            <Form.Group className="form-group" controlId="formLastName">
                                <Form.Label> Название компании </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='companyName'
                                    value={companyName} 
                                    onBlur={blurHandler}
                                    onChange={companyNameHandler}
                                    isInvalid={!!(companyNameDirty && companyNameError)} 
                                />
                                {(companyNameDirty && companyNameError) && <p className="error-alert">{companyNameError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formFirstName" style={{ marginBottom: '32px' }}>
                                <Form.Label> Сайт </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='website'
                                    value={website} 
                                    onBlur={blurHandler}
                                    onChange={websiteHandler}
                                    isInvalid={!!(websiteDirty && websiteError)} 
                                />
                                {(websiteDirty && websiteError) && <p className="error-alert">{websiteError}</p>}
                            </Form.Group>
                            <h2 style={{ marginBottom: '20px' }}> Адрес офиса</h2>
                            <div className="pair-input">
                                <div className="form-group first-in-pair">
                                    <Form.Label> Область </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='area'
                                        value={area} 
                                        onBlur={blurHandler}
                                        onChange={areaHandler}
                                        isInvalid={!!(areaDirty && areaError)} 
                                    />
                                    {(areaDirty && areaError) && <p className="error-alert">{areaError}</p>}
                                </div>
                                <div className="form-group second-in-pair">
                                    <Form.Label> Город </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='city'
                                        value={city} 
                                        onBlur={blurHandler} 
                                        onChange={cityHandler}
                                        isInvalid={!!(cityDirty && cityError)} 
                                    />
                                    {(cityDirty && cityError) && <p className="error-alert">{cityError}</p>}
                                </div>
                            </div>
                            <div className="pair-input">
                                <div className="form-group first-in-pair">
                                    <Form.Label> Улица </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='street'
                                        value={street} 
                                        onBlur={blurHandler} 
                                        onChange={streetHandler}
                                        isInvalid={!!(streetDirty && streetError)} 
                                    />
                                    {(streetDirty && streetError) && <p className="error-alert">{streetError}</p>}
                                </div>
                                <div className="form-group second-in-pair">
                                    <Form.Label> Дом </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='house'
                                        value={house} 
                                        onBlur={blurHandler} 
                                        onChange={houseHandler}
                                        isInvalid={!!(houseDirty && houseError)} 
                                    />
                                    {(houseDirty && houseError) && <p className="error-alert">{houseError}</p>}
                                </div>
                            </div>
                            <br />
                            <Button type="primary" onClick={handleContinue}> Продолжить </Button>
                            <Button type="text" onClick={() => navigate("/fillProfile3")}> Пропустить </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <Styles>
                <div className="progress"></div>
            </Styles>
        </>
    );
};